export default () => {
    const secondaryCol = document.querySelector('.individualCaseStudy__secondary');
    const btn = document.querySelector('.individualCaseStudy__action .btn p');

    function toggleContent() {
        if (secondaryCol.classList.contains('is-active')) {
            // Scroll immediately before collapsing content
            secondaryCol.scrollIntoView({ behavior: "smooth", block: "start" });
            secondaryCol.classList.remove('is-active');
            setTimeout(() => {
                btn.textContent = "Read more";
            }, 100); // Delay text change by 0.5 seconds
        } else {
            secondaryCol.classList.add('is-active');
            btn.textContent = "Read less";
        }
    }

    if (secondaryCol && btn) {
        secondaryCol.classList.remove('is-active');
        btn.textContent = "Read more";
        document.querySelector('.individualCaseStudy__action').addEventListener("click", toggleContent);
    }

    const secondaryColResource = document.querySelector('.IndividualResourcePage__secondary');
    const btnResource = document.querySelector('.IndividualResourcePage__action .btn p');

    function toggleContentResource() {
        if (secondaryColResource.classList.contains('is-active')) {
            // Scroll immediately before collapsing content
            secondaryColResource.scrollIntoView({ behavior: "smooth", block: "start" });
            secondaryColResource.classList.remove('is-active');
            setTimeout(() => {
                btnResource.textContent = "Read more";
            }, 100); // Delay text change by 0.5 seconds
        } else {
            secondaryColResource.classList.add('is-active');
            btnResource.textContent = "Read less";
        }
    }

    if (secondaryColResource && btnResource) {
        secondaryColResource.classList.remove('is-active');
        btnResource.textContent = "Read more";
        document.querySelector('.IndividualResourcePage__action').addEventListener("click", toggleContentResource);
    }
}
